import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    MatButtonModule,
    MatDialogModule,
    MatIconModule, MatInputModule,
    MatSnackBarModule
} from '@angular/material';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {Providers as BootstrapProviders} from '../di_providers/bootstrap';
import {Providers as MetadataProviders} from '../di_providers/metadata';
import {Providers as ConfigProviders} from '../di_providers/config';
import {Providers as EnvironmentProviders} from '../di_providers/environment';
import {Providers as RegisterProviders} from '../di_providers/register';
import {Providers as LoggerProviders} from '../di_providers/logger';
import {Providers as EventManagerProviders} from '../di_providers/event_management';
import {Providers as ErrorProviders} from '../di_providers/error';
import {Providers as CacheProviders} from '../di_providers/cache';
import {Providers as CroneProviders} from '../di_providers/background_worker';
import {Providers as CommandsProviders} from '../di_providers/backend';
import {Providers as FormProviders} from '../di_providers/form';
import {Providers as ModalDialogProviders} from '../di_providers/modal_dialog';
import {Providers as TelephoneInputProviders} from '../di_providers/telephone_input';
import {Providers as DateTimeProviders} from '../di_providers/date_time';
import {Providers as ObjectWrapperProviders} from '../di_providers/object_wrapper';
import {Providers as RandomProviders} from '../di_providers/random';

import {ModalComponent} from './Error/Task/DisplayToModal/Component/modal.component';
import {CarouselComponent} from './Carousel/carousel.component';
import {TelephoneInputComponent} from './TelephoneInput/telephone-input.component';
import {Ng2TelInputModule} from 'ng2-tel-input';
import {IMaskModule} from 'angular-imask';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    declarations: [
        ModalComponent,
        CarouselComponent,
        TelephoneInputComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        MatDialogModule,
        MatSnackBarModule,
        NgbModule.forRoot(),
        Ng2TelInputModule,
        IMaskModule
    ],
    providers: [
        BootstrapProviders,
        MetadataProviders,
        ConfigProviders,
        EventManagerProviders,
        EnvironmentProviders,
        RegisterProviders,
        LoggerProviders,
        ErrorProviders,
        CacheProviders,
        CroneProviders,
        CommandsProviders,
        FormProviders,
        ModalDialogProviders,
        TelephoneInputProviders,
        DateTimeProviders,
        ObjectWrapperProviders,
        RandomProviders
    ],
    entryComponents: [
        ModalComponent
    ],
    exports: [
        CarouselComponent,
        TelephoneInputComponent,

        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatSnackBarModule,
        MatInputModule,
        NgbModule,
        Ng2TelInputModule,
        IMaskModule
    ]
})
export class CoreModule {

}
